window.addEventListener('DOMContentLoaded', () => {

    // class helper functions
    const removeClass = (el, classname) => {
        el.className = el.className.replace(" " + classname, "");
        el.className = el.className.replace(classname, "");
    }
    const addClass = (el, classname) => {
        if (!hasClass(el, classname)) {
            el.className += " " + classname;
        }
    }
    const hasClass = (el, classname) => {
        return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
    }

    // Find the first ancestor with a particular classname
    const findAncestor = (el, cls) => {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    // elements we reference mutliple times
    const searchbox = document.getElementById('progsearch');
    const checkboxes = document.querySelectorAll('.wp-block-programs-of-study input[type="checkbox"]');
    const schoolCheckboxes = document.querySelectorAll('.wp-block-programs-of-study input[type="checkbox"][name="school"]');
    const progtypeCheckboxes = document.querySelectorAll('.wp-block-programs-of-study input[type="checkbox"][name="progtype"]');
    const radios = document.querySelectorAll('.wp-block-programs-of-study input[type="radio"]');
    const announcer = document.getElementById('posAnnouncer');

    const progsearchWrapper = document.querySelector('.progsearch-wrapper');
    const progCountWrapper = document.querySelector('.count-wrapper');
    const progCount = document.getElementById('progCount');
    const progtypeCount = document.getElementById('progtypeCount');
    const schoolCount = document.getElementById('schoolCount');
    const programlist = document.getElementById('programlist');

    // get program data from local storage
    const localPrograms = localStorage.getItem("progData") !== null && localStorage.getItem("progDataExpiration") > Date.now() ?
        JSON.parse(localStorage.getItem("progData")) :
        false;

    // create object to store programs
    const programs = {
        loaded: localPrograms === false ? false : true,
        loading: false,
        progData: localPrograms === false ? [] : localPrograms
    };

    // if this is a homepage style, hide the program list on load
    if (ajax_data.is_homepage) {
        programlist.style.display = 'none';
    }

    // for combobox, set active descendant (the pseudo-focused program)
    const setActiveDescendant = (option = null) => {

        // remove any aria-selected roles
        const allCards = document.querySelectorAll('.programlist .program a');
        [].forEach.call(allCards, card => card.removeAttribute('aria-selected'));

        // set the current active descendant if there is one
        if (option) {
            option.focus()
        } else {
            searchbox.removeAttribute('aria-activedescendant');
        }
        
    };
    const getActiveDescendant = () => {
        if (hasClass(document.activeElement, 'program-url')) {
            return document.activeElement;
        } else if (hasClass(document.activeElement, 'programsearch')) {
            return searchbox.getAttribute('aria-activedescendant');
        }
    }

    // function that grabs all required values and forms necessary params
    const paramGrab = () => {
        const progsearch = searchbox ? searchbox.value : '';

        const sort = document.querySelector('input[name="sort"]:checked') ? 
            document.querySelector('input[name="sort"]:checked').value :
            'asc';

        const ptInputs = document.querySelectorAll('input[name="progtype"]:checked');
        const ptHiddens = document.querySelectorAll('input[name="progtype"][type="hidden"]');
        const progtype = [].reduce.call([...ptInputs, ...ptHiddens], (carry, current) => {
            return carry.length == 0 ? carry + current.value : carry + ',' + current.value
        }, '');

        const schoolInputs = document.querySelectorAll('input[name="school"]:checked');
        const schoolHiddens = document.querySelectorAll('input[name="school"][type="hidden"]');
        const school = [].reduce.call([...schoolInputs, ...schoolHiddens], (carry, current) => {
            return carry.length == 0 ? carry + current.value : carry + ',' + current.value
        }, '');

        const progdepartmentHiddens = document.querySelectorAll('input[name="progdepartment"][type="hidden"]');
        const progdepartment = [].reduce.call(progdepartmentHiddens, (carry, current) => {
            return carry.length == 0 ? carry + current.value : carry + ',' + current.value
        }, '');

        return ({
            progsearch,
            sort,
            progtype,
            school,
            progdepartment
        })
    }

    // grab query string vars
    // query string grabber
    const qs_val = param => {

        // try URLSearchParams first
        if ('URLSearchParams' in window) {
            const urlParams = new URLSearchParams(window.location.search);
            const theVal = urlParams.get(param);
            return theVal;
        }

        // if no URLSearchParams support, use regex
        const url = window.location.href;
        const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url)
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return null;
        }
        const theVal = decodeURIComponent(results[2]);
        return theVal;
    }

    // determine loading indicator displays or not
    const indicateLoadingIfLoading = () => {
        if (programs.loading) {
            if (progCountWrapper && progCountWrapper.getAttribute('aria-busy') != true) {
                progCountWrapper.setAttribute('aria-busy', 'true');
            }
            if (progsearchWrapper && progsearchWrapper.getAttribute('data-loading') != 'true') {
                progsearchWrapper.setAttribute('data-loading', 'true');
            }
        }
    }

    // fetch program data
    const fetch_programs = async listboxOverride => {
        if (programs.loading) {
            return;
        }
        // grab program data from ajax call
        if (!programs.loaded) {
            let page = 1;
            let total = 1;
            programs.loading = true;
            const academicsURL = 'https://www.monmouth.' + window.location.origin.split(".").slice(-1).pop() + '/academics/wp-json';

            try {
                do {
                    const res = await fetch(`${academicsURL}/wp/v2/programs?order=asc&orderby=title&per_page=100&page=${page}`);
                    
                    if (!res.ok) {
                        throw new Error('Failed to grab program data.');
                    }
                    programs.progData = [...programs.progData, ...(await res.json())];
                    page++;
                    total = res.headers.get('x-wp-totalpages');
                } while (page <= total);
                if (page > total) {
                    programs.progData = programs.progData.map(prog => ({
                        title: prog.title.rendered,
                        slug: prog.slug,
                        block_data: prog.block_data,
                        term_info: prog.term_info,
                        meta: prog.meta
                    }))
                    programs.loaded = true;
                    programs.loading = false;
                    localStorage.setItem("progData", JSON.stringify(programs.progData));
                    localStorage.setItem("progDataExpiration", Date.now() + 300000) // 5 mins from now
                    if (progCountWrapper) {
                        progCountWrapper.removeAttribute('aria-busy');
                    }
                    if (progsearchWrapper) {
                        progsearchWrapper.removeAttribute('data-loading');
                    }
                }
            } catch (err) {
                console.error("Something went wrong while trying to grab the programs. " + err.message);
            }
        }

        // grab the elements we'll need to edit 
        const clearFilterBtn = document.getElementById('clearFilters');

        // grab the params
        const {
            progsearch,
            progtype,
            school,
            progdepartment,
            sort
        } = paramGrab();

        // if this is the homepage style and we have no search value, don't include anything in the program list
        if (ajax_data.is_homepage && (progsearch === '' && !listboxOverride)) {
            programlist.innerHTML = '';
            searchbox.setAttribute('aria-expanded', 'false');
            return;
        }

        // replace the current url state
        if (!ajax_data.is_homepage) {
            const pieces = [{ progsearch }, { progtype }, { school }, { sort }]
            const pushUrl = pieces.reduce((carry, obj) => {
                const [key, value] = (Object.entries(obj))[0]
                if (value.length > 0) {
                    return carry.length == 0 ? `?${key}=${value}` : carry + `&${key}=${value}`
                }
                return carry;
            }, '');
            history.replaceState({}, null, pushUrl);
        } 

        // check for existence of main and sub progtypes
        const hasMainPTs = progtype.split(',').filter(slug => slug == 'ug' || slug == 'gr').length > 0;
        const hasSubPTs = progtype.split(',').filter(slug => slug != 'ug' && slug != 'gr').length > 0;

        // how many matching progtypes to check for, depending on whether main progtypes AND subprogtypes are selected
        const ptMeter = (hasMainPTs && hasSubPTs) ? 2 : 1;

        // load programs from ajax if not yet done
        
        // filter out the programs we need
        const progsForCards = progsearch == '' && progtype == '' && school == '' && progdepartment == '' && ajax_data.filter_keyword == '' ?
            programs.progData :
            programs.progData.filter(prog => {

                const search = progsearch.replace(/,/g, ' ').replace(/\./g, '').toLowerCase();
                const keywords = search.split(' ');
                const extraSearch = ajax_data.filter_keyword.replace(/,/g, ' ').replace(/\./g, '').toLowerCase();
                const extraKeywords = extraSearch.split(' ');

                const ptCleared = progtype == '' ?
                    true :
                    progtype.split(',').filter(slug => prog.term_info.slugs.progtype.indexOf(slug) !== -1).length >= ptMeter;

                const schoolCleared = school == '' ?
                    true :
                    school.split(',').filter(slug => prog.term_info.slugs.school.indexOf(slug) !== -1).length > 0;
                const departmentCleared = progdepartment == '' ?
                    true :
                    progdepartment.split(',').filter(slug => prog.term_info.slugs.progdepartment.indexOf(slug) !== -1).length > 0;
                const kwSearchCleared = progsearch == '' ?
                    true :
                    keywords.filter(slug => prog.term_info.keywords.join(' ').replace(/\./g, '').toLowerCase().indexOf(slug) !== -1).length > 0;
                const titleSearchCleared = progsearch == '' ?
                    true :
                    keywords.filter(slug => prog.title.replace(/\./g, '').toLowerCase().indexOf(slug) !== -1).length > 0;

                // extra keywords (from the filter)
                const extraKwSearchCleared = ajax_data.filter_keyword == '' 
                    ? true
                    : extraKeywords.filter(slug => prog.term_info.keywords.join(' ').replace(/\./g, '').toLowerCase().indexOf(slug) !== -1).length == extraKeywords.length;
                
                const extraTitleSearchCleared = ajax_data.filter_keyword == '' ?
                    true :
                    extraKeywords.filter(slug => prog.title.replace(/\./g, '').toLowerCase().indexOf(slug) !== -1).length  == extraKeywords.length;
                return ptCleared && schoolCleared && departmentCleared && (kwSearchCleared || titleSearchCleared) && ( extraKwSearchCleared || extraTitleSearchCleared );
            })
        
        const alphaSortedProgsForCards = [...progsForCards].sort((a, b) => {
            const a_title = a.title.replace(/^(\w+\.)+ /i, '')
                .replace(/^(in |– |&#8211; |with a Concentration in )/i, '')
                .replace('Doctor of ', '')
                .replace('Graduate Endorsement: ', '');
            const b_title = b.title.replace(/^(\w+\.)+ /i, '')
                .replace(/^(in |– |&#8211; |with a Concentration in )/i, '')
                .replace('Doctor of ', '')
                .replace('Graduate Endorsement: ', '');

            if (sort !== 'desc') {
                if (a_title < b_title) {
                    return -1;
                }
                if (a_title > b_title) {
                    return 1;
                }
                return 0;
            } else {
                if (a_title < b_title) {
                    return 1;
                }
                if (a_title > b_title) {
                    return -1;
                }
                return 0;
            }
        })

        const rankProgByPT = prog => {
            if ( 'sortable_slug' in prog.term_info.slugs === false ) {
                return 9;
            }
            switch ( prog.term_info.slugs.sortable_slug ) {
                case 'bachelors':
                    return 1;
                case 'minor':
                    return 2;
                case 'doctorate':
                    return 3;
                case 'masters':
                    return 4;
                case 'gr-certificate':
                    return 5;
                case 'gr-endoresement':
                    return 6;
                case 'ug-certificate':
                    return 7;
                case 'ug-endoresement':
                    return 8;
                default:
                    return 9;
            }
        }

        // rank by the index for custom sort
        const rankProgByPT_AlternateSort = (prog, sortType = 'normal') => {
            if ( 'sortable_slug' in prog.term_info.slugs === false || 'expanded_slug' in prog.term_info.slugs === false ) {
                return 200;
            }
            if (sortType == 'normal') {
                return ajax_data.alternateSortOrder.findIndex(slug => slug == prog.term_info.slugs.sortable_slug)
            } else if (sortType == 'expanded') {
                return ajax_data.alternateSortExpandedOrder.findIndex(slug => slug == prog.term_info.slugs.expanded_slug)
            }

            return 1;
        }
        
        // determine if we are using expanded order or not
        const customSortType = ajax_data.expandAlternateSort ? 'expanded' : 'normal';

        // run all applicable sorting functions to arrive at desired order
        const sortedProgsForCards = ajax_data.sort_by_programtype == false ?
            alphaSortedProgsForCards :
            [...alphaSortedProgsForCards].sort((a, b) => {
                const a_rank = ajax_data.alternateSort ? rankProgByPT_AlternateSort(a, customSortType) : rankProgByPT(a);
                const b_rank = ajax_data.alternateSort ? rankProgByPT_AlternateSort(b, customSortType) : rankProgByPT(b);
                if (a_rank > b_rank) {
                    return 1;
                }
                if (a_rank < b_rank) {
                    return -1;
                }
                return 0;
            })

        // Find all possible filters for the remaining programs
        const found = sortedProgsForCards.length == programs.progData.length ?
            { progtypes: [], schools: [] } :
            sortedProgsForCards.reduce((carry, prog) => {
                prog.term_info.slugs.progtype.forEach(slug => {
                    if (carry.progtypes.indexOf(slug) === -1) {
                        carry.progtypes.push(slug);
                    }
                });
                prog.term_info.slugs.school.forEach(slug => {
                    if (carry.schools.indexOf(slug) === -1) {
                        carry.schools.push(slug);
                    }
                });
                return carry;
            }, { progtypes: [], schools: [] });

        // if there are no programs, disable the unchecked, so users can remove selected filters
        if (sortedProgsForCards.length == 0) {
            [].forEach.call(checkboxes, checkbox => {
                if (checkbox.checked) {
                    checkbox.removeAttribute('disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        removeClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                } else {
                    checkbox.setAttribute('disabled', 'disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        addClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                }
            });
        } else {
            // go through each checkbox, determine if no progcards match and, if so, disable. Otherwise, enable.
            [].forEach.call(progtypeCheckboxes, checkbox => {
                if (found.progtypes.length == 0 || found.progtypes.indexOf(checkbox.value) !== -1) {
                    checkbox.removeAttribute('disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        removeClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                } else {
                    checkbox.setAttribute('disabled', 'disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        addClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                }
            });

            [].forEach.call(schoolCheckboxes, checkbox => {
                if (found.schools.length == 0 || found.schools.indexOf(checkbox.value) !== -1) {
                    checkbox.removeAttribute('disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        removeClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                } else {
                    checkbox.setAttribute('disabled', 'disabled');
                    if (document.querySelector(`label[for="${checkbox.value}"]`)) {
                        addClass(document.querySelector(`label[for="${checkbox.value}"]`), 'disabled');
                    }
                }
            });
        }
        
        // construct the programCards html
        const progCards = sortedProgsForCards.map(({
            title: p_title,
            slug: p_slug,
            block_data: {
                description: p_description,
                progurl: p_progurl
            },
            term_info: {
                names: {
                    school: a_school,
                    mainprogtype: a_progtype,
                    subprogtype: a_degreetype,
                    progdepartment: a_progdepartment
                }
            },
            meta: {
                bstoms: p_bstoms
            }
        }, i) => {
            const p_school = a_school.join(',');
            const p_progtype = a_progtype.join(',');
            const p_degreetype = a_degreetype.join(',');
            const p_progdepartment = a_progdepartment.join(',');

            const slug = p_slug != undefined ? p_slug : `program-${i}`;

            const bstomsHTML = p_bstoms ?
                `<p class="program-bplusm">
                <span class="combo">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" xmlns:xlink="http://www.w3.org/1999/xlink" class="top" viewBox="0 0 253.82 126.91">
                        <path d="M253.82 126.91V80.42h-87.86V0h-78.1v80.42H0v46.49h253.82z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" xmlns:xlink="http://www.w3.org/1999/xlink" class="bottom" viewBox="0 0 253.8 126.9">
                        <path d="M0 0v46.5h87.9v80.4H166V46.5h87.8V0z"></path>
                    </svg>
                </span> Bachelors + Masters
            </p>` :
                '';

            const progtypeHTML = `<p class="program-type">${p_progtype} | ${p_degreetype}</p>`;

            // on homepage pos, if the degreetype is a minor, endorsement, or certificate, add it to the card
            const degreeTypeSpan = ajax_data.is_homepage && (
                p_degreetype.indexOf('Certificate') !== -1 ||
                p_degreetype.indexOf('Endorsement') !== -1
            ) ? 
                ` <span class='degree-type-tag'>(${p_progtype} ${p_degreetype})</span>` 
            :
                ( 
                    ajax_data.is_homepage && p_degreetype.indexOf('Minor') !== -1 ? 
                    ` <span class='degree-type-tag'>(${p_degreetype})</span>` :
                    ''
                );


            const progareaHTML = p_progdepartment ?
                "<div class='program-area'>" +
                "<p>" + p_school + "</p>" +
                "<p>" + p_progdepartment + "</p>" +
            "</div>" :
                "<div class='program-area'>" +
                "<p>" + p_school + "</p>" +
            "</div>";

            const tabIndex = ajax_data.is_homepage ? " " : '';

            if (ajax_data.is_homepage) {
                return "<div class='program card'>" +
                    "<div class='program-header'>" +
                        "<div>" +
                            "<p class='program-title'><a role='option' class='program-url' id='" + slug + "' href='" + p_progurl + "'>" + p_title + degreeTypeSpan + "</a></p>" +
                        "</div>" +
                    "</div>" +
                "</div>";
            }

            return "<div class='program card'>" +
                "<div class='program-header'>" +
                    "<div>" +
                        "<p class='program-title'><a class='program-url' id='" + slug + "' href='" + p_progurl + "'" + tabIndex + "'>" + p_title + degreeTypeSpan + "</a></p>" +
                        progtypeHTML +
                    "</div>" +
                    progareaHTML +
                "</div>" +
                p_description +
                bstomsHTML +
            "</div>"
        });


        // append the cards
        programlist.innerHTML = progCards.length > 0 ?
        progCards.join('') :
        '<div class="no-programs"><p>No Programs Found for Your Query</p></div>';
        

        // edit the program count element
        if (progCount) {
            progCount.innerText = progCards.length > 0 ? `Showing ${progCards.length} Programs` : '';
        }

        // determine style of clear filter button based on whether there's filters
        if (clearFilterBtn) {
            clearFilterBtn.style.display = (progtype != '' && progtypeCheckboxes.length > 0) || (school != '' && schoolCheckboxes.length > 0) || progsearch != '' ? null : 'none';
        }
        
        if (announcer) {
            if (progsearch != '' && progCards.length > 1) {
                announcer.innerText = `${progCards.length} options available, use Down Arrow to access`;
            } else if (progsearch != '' && progCards.length == 1) {
                announcer.innerText = 'One option available, use Down Arrow to access';
            } else if (progsearch != '') {
                announcer.innerText = 'No Results Found';
            } else {
                announcer.innerText = '';
            }
        }

        searchbox.setAttribute('aria-expanded', 'true');
        setActiveDescendant();
    }

    // change count of filter inputs
    const countFilters = () => {
        // edit the filter count elements
        if (progtypeCount) {
            const checkedPtsTally = progtypeCheckboxes ? [].filter.call(progtypeCheckboxes, checkbox => checkbox.checked).length : '0';
            progtypeCount.innerText = `${checkedPtsTally}`;
        }
        if (schoolCount) {
            const checkedSchoolsTally = schoolCheckboxes ? [].filter.call(schoolCheckboxes, checkbox => checkbox.checked).length : '0';
            schoolCount.innerText = `${checkedSchoolsTally}`;
        }
    }

    // event action for search
    const searchEventHandler = () => {
        const search = document.getElementById('progsearch') ? document.getElementById('progsearch').value : '';
        const searchParam = qs_val('progsearch');
        // only run this if the search has changed
        if (document.getElementById('progsearch') && search != searchParam) {
            fetch_programs();
            indicateLoadingIfLoading();
        }
    }

    // typing in the search bar
    let searchTimeout;
    const searchEl = document.getElementById('progsearch');
    if (searchEl) {
        searchEl.addEventListener('keydown', e => {
            clearTimeout(searchTimeout);
            if (e.code == 'Escape') {
                searchEl.value = '';
                searchEventHandler();
            } else if (e.code == 'Enter' && !getActiveDescendant()) {
                searchEventHandler();
            } else if (
                e.code != 'Enter' && 
                e.code != 'Tab' && 
                e.code != 'ArrowDown' && 
                e.code != 'ArrowUp' && 
                e.code != 'ShiftLeft' && e.code != 'ShiftRight' &&
                e.code != 'MetaLeft' && e.code != 'MetaRight' &&
                e.code != 'AltLeft' && e.code != 'AltRight' &&
                e.code != 'ControlLeft' && e.code != 'ControlRight') {
                // change + 250ms
                searchTimeout = setTimeout(() => {
                    searchEventHandler()
                }, 250);
            }
        });
    }

    // prevent form from submitting on enter
    document.addEventListener('keydown', e => {
        if (findAncestor(document.activeElement, 'wp-block-programs-of-study') && !hasClass(e.target, 'program-url'))  {
            if (e.code == 'Enter') {
                if (ajax_data.is_homepage) {
                    const currentEl = getActiveDescendant();
                    if (currentEl){
                        e.preventDefault();
                        window.open(currentEl.href).blur()
                        window.focus();
                    }
                } else {
                    e.preventDefault();
                }
            }
        }   
    });

    // change events on checkboxes
    [].forEach.call(checkboxes, checkbox => {
        checkbox.addEventListener('change', (e) => {
            const parent = e.target.getAttribute('value');
            const children = document.querySelectorAll(`[data-parent="${parent}"]`);
            if (parent && e.target.checked == false) {
                [].forEach.call(children, child => {
                    if (child.getAttribute('disabled') === 'disabled') {
                        child.checked = false
                    } else {
                        child.checked = e.target.checked
                    }
                })
            }
            fetch_programs();
            indicateLoadingIfLoading();
            if (parent && e.target.checked == true) {
                const children = document.querySelectorAll(`[data-parent="${parent}"]`);
                [].forEach.call(children, child => {
                    if (child.getAttribute('disabled') === 'disabled') {
                        child.checked = false
                    } else {
                        child.checked = e.target.checked
                    }
                })
            }
            countFilters();
        })
    });

    // change events on radios
    [].forEach.call(radios, radio => {
        radio.addEventListener('change', (e) => {
            fetch_programs();
            indicateLoadingIfLoading();
            countFilters();
        })
    }); 

    const clearFilterBtn = document.getElementById('clearFilters');
    if (clearFilterBtn) {
        clearFilterBtn.addEventListener('click', (e) => {
            e.preventDefault();
            [].forEach.call(checkboxes, checkbox => {
                if (checkbox.checked) {
                    checkbox.checked = false;
                }
            })
            if (searchbox) {
                searchbox.value = '';
            }
            indicateLoadingIfLoading();
            fetch_programs();
            countFilters();
        })
    }
    if (ajax_data.is_homepage) {
        document.body.addEventListener('keydown', e => {
            const code = 'code' in e ? e.code : null;
            if (hasClass(document.activeElement, 'progsearch') || hasClass(document.activeElement, 'program-url')) {
                const currentEl = getActiveDescendant();
                const allCards = document.querySelectorAll('.programlist .program a');
                const revAllCards = [...allCards].reverse()
                const firstCard = document.querySelector('.programlist .program a');
                const lastCard = allCards.length > 0 ? allCards[allCards.length - 1] : null;
                let idCheck = false;
                // if search input is active and user hits down or tab
                if (hasClass(document.activeElement, 'progsearch')) {
                    switch (code) {
                        case 'ArrowDown':   
                            // if holding Alt, simply displays the listbox without changing visual focus   
                            if (e.altKey) {
                                e.preventDefault();
                                if (progsearch.value.length == 0 && programlist.innerHTML.length == 0) {
                                    fetch_programs(true);
                                }
                                programlist.style.display = null;
                                searchbox.setAttribute('aria-expanded', 'true');
                            } else {
                                if (firstCard) {
                                    e.preventDefault();
                                    firstCard.focus();
                                }
                            } 
                        break;
                        case 'ArrowUp':
                            // if holding alt, close popup and remove listbox stuff
                            if (e.altKey) {
                                e.preventDefault();
                                programlist.style.display = 'none';
                                searchbox.setAttribute('aria-expanded', 'false');
                                fetch_programs();
                            } else {
                                if (lastCard) {
                                    e.preventDefault();
                                    lastCard.focus();
                                }
                            } 
                        break
                        case 'Tab':
                            if ( e.shiftKey !== true ) {
                                if (firstCard) {
                                    e.preventDefault();
                                    firstCard.focus();
                                }
                            }
                        break;
                        case 'Escape':
                            // go back to search el
                            e.preventDefault();
                            searchEl.value = '';
                            fetch_programs();
                        break;
                    }
                } else if (hasClass(document.activeElement, 'program-url')) {
                    switch (code) {
                        case 'ArrowDown':
                            // select next program if it's there. If not, go to first prog
                            if (currentEl) {
                                e.preventDefault();
                                const nextCard = [].filter.call(allCards, card => {
                                    if (idCheck){
                                        idCheck = false;
                                        return card;
                                    }
                                    if (card.id == currentEl.id) {
                                        idCheck = true;
                                    }
                                });
                                if (nextCard.length > 0) {
                                    nextCard[0].focus();
                                } else {
                                    firstCard.focus();
                                }
                            }
                        break;
                        case 'ArrowUp':
                            // select next program if it's there. If not, go to last prog
                            if (currentEl) {
                                e.preventDefault();
                                const prevCard = [].filter.call(revAllCards, card => {
                                    if (idCheck){
                                        idCheck = false;
                                        return card;
                                    }
                                    if (card.id == currentEl.id) {
                                        idCheck = true;
                                        console.log(true);
                                    }
                                })
                                if (prevCard.length > 0) {
                                    setActiveDescendant(prevCard[0]);
                                } else {
                                    setActiveDescendant(lastCard);
                                }
                            }
                            break;
                        case 'Escape':
                            // go back to search el
                            e.preventDefault();
                            searchEl.value = '';
                            searchEl.focus()
                            fetch_programs();
                    }
                    // check if a printable key or backspace was pressed, and if so, send it to the search input
                    if (e.key && (e.key.length == 1 || e.code == 'Backspace' || e.code == 'Space')) {
                        searchEl.focus();
                        const kbDown = new KeyboardEvent('keydown', {key: e.key, bubbles:true});
                        // const kbPress = new KeyboardEvent('keypress', {key: e.key, bubbles:true});
                        // const kbUp = new KeyboardEvent('keyup', {key: e.key, bubbles:true});
                        searchEl.dispatchEvent(kbDown);
                        // searchEl.dispatchEvent(kbPress);
                        // searchEl.dispatchEvent(kbUp);
                        searchEl.dispatchEvent((new Event('change', {bubbles: true})));
                    }
                } 
            }
        });
        

        document.body.addEventListener('focusout', e => {
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && hasClass(relatedTarget, 'program-url') || hasClass(relatedTarget, 'programlist')) {
                return;
            }
            programlist.style.display = 'none';
            searchbox.setAttribute('aria-expanded', 'false');
            setActiveDescendant();
        });

        document.body.addEventListener('focusin', e => {
            const isSearch = hasClass(e.target, 'progsearch');
            if ( isSearch ) {
                programlist.style.display = null;
                if (programlist.innerHTML.length != 0) {
                    searchbox.setAttribute('aria-expanded', 'true');
                }
            }
        });
    }

    // begin fetching programs once the user focuses on the form
    document.body.addEventListener('focusin', e => {
        const isSearchable = findAncestor(e.target, 'programs-of-study');
        if (isSearchable) {
            fetch_programs();
        }
    })
});
